import React from "react";
import loadingIcon from "../../assets/images/loading-icon.gif";
import loadingHeader from "../../assets/images/loading-header.png";

const Loader2 = () => {
  return (
    <div className="loader-overlay" style={{
      
     backgroundColor:"rgb(242 , 242, 242, 0.9)"
      
    }}>
      <div
        style={{
          width: "200px",
          height:"180px",
          justifyContent:"center",
          alignItems:"center",
          borderRadius: 25,
        }}
      >
        <div
          style={{
            padding: "40px 0px 0px 0px",
            width: "100%",
            height: "100%",
            backgroundColor:"#ffffff",
            display: "flex",
            bottom: 15,
            borderRadius: 25,
            justifyContent: "center",
            gap: 24,
          }}
        >
          <div
            style={{
              width: 50,
              height: 50,
              resizeMode: "contain",
            }}
          >
            <img
              style={{ height: "100%", width: "100%" }}
              src={loadingHeader}
              alt="header"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 7,
                fontSize: "19px",
                fontWeight: "bold"
              }}
            >
              Loading
              <img
                style={{ height: "100%", width: 50, resizeMode: "contain" }}
                src={loadingIcon}
                alt="Loading"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader2;
